import { formatCurrency } from "@/utils"
import type { OrderAmountDueBreakdownTableProps } from "./OrderAmountDueBreakdownTable.types"

export interface OrderAmountDueBreakdownRow {
  key: string
  item: string
  amount: string
}

export const createOrderAmountDueBreakdownRows = ({
  order,
}: OrderAmountDueBreakdownTableProps): OrderAmountDueBreakdownRow[] => {
  const subtotalAmount = order.subtotalAmount ?? 0
  const discountAmount = order.discountAmount ?? 0
  const taxAmount = order.taxAmount ?? 0
  const totalAmount = order.totalAmount ?? 0
  const platformFeeAmount = order.platformFeeAmount ?? 0
  const stripeFeeAmount = order.stripeFeeAmount ?? 0
  const memberPaysTotal = order.memberPaysTotal ?? totalAmount

  return [
    {
      key: "subtotal",
      item: "Subtotal",
      amount: formatCurrency(subtotalAmount),
    },
    {
      key: "discounts",
      item: "Discounts",
      amount: `-${formatCurrency(discountAmount)}`,
    },
    { key: "tax", item: "Tax", amount: `+${formatCurrency(taxAmount)}` },
    {
      key: "order-total",
      item: "Order Total",
      amount: formatCurrency(totalAmount),
    },
    {
      key: "platform-fee",
      item: "Platform Fee",
      amount: `+${formatCurrency(platformFeeAmount)}`,
    },
    {
      key: "processor-fee",
      item: "Processor Fee",
      amount: `+${formatCurrency(stripeFeeAmount)}`,
    },
    {
      key: "member-total",
      item: "Member Total",
      amount: formatCurrency(memberPaysTotal),
    },
  ]
}
